import styled from "styled-components";

export const CardInformations = styled.div`
  max-width: 407px;
  width: 100%;
  min-height: 288;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  gap: 20px;
  align-items: center;
  border-bottom: 3px solid #139ed5;

  img {
    border-radius: 50%;
    width: 150px;
    height: 150px;
    border: 5px solid #139ed5;
    margin-top: -100px;
  }

  h3 {
    color: #1d364a;
    font-size: 24px;
    font-family: "Noto Serif";
    text-align: center;
  }
  ul {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    font-family: "Montserrat";
    padding-left: 20px;
    width: 100%;
    text-align: start;
  }

  @media (max-width: 768px) {
    margin-top: 100px;
  }
`;
